import * as yup from 'yup'

import { EMAIL_REGEX_FORMAT, trimmedInputValues } from '../utils'

const extractEmail = (value) => {
    if (!value){
        return value
    }
    const match = value.match(/<([^>]+)>/)
    return match ? match[1] : value
}

const sendEmailDetails = {
    to: "",
    from: "",
    kam: "",
    cc: "",
    subject: "",
    message: ""
}

const sendEmailValidationSchema = yup.object().shape({
    to: yup.string()
        .transform((value) => trimmedInputValues(value))
        .matches(EMAIL_REGEX_FORMAT, 'Please enter valid email')
        .required('This Field is required'),
    from: yup.string()
        .transform((value) => trimmedInputValues(value))
        .matches(EMAIL_REGEX_FORMAT, 'Please enter valid email')
        .required('This Field is required'),
    kam: yup.string()
        .transform((value) => trimmedInputValues(value))
        .matches(EMAIL_REGEX_FORMAT, 'Please enter valid email')
        .required('This Field is required'),
    subject: yup.string().required('This Field is required').trim(),
    message: yup.string().required('This Field is required').trim(),
    cc: yup.array().of(yup.string()
        // .transform((value) => trimmedInputValues(value))
        .transform((value) => extractEmail(value).trim())
        .matches(EMAIL_REGEX_FORMAT, 'Please enter valid email')) 
})

/*
    cc: yup.array().of(yup.string()
                                    .transform((value) => trimmedInputValues(value))
                                    .matches(EMAIL_REGEX_FORMAT, 'Please enter valid email')).min(1).required('This Field is required'),  
*/


export { sendEmailDetails, sendEmailValidationSchema}